import React from "react";

function TickIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        id="Path_19901"
        data-name="Path 19901"
        d="M14,26A12,12,0,1,1,26,14,12,12,0,0,1,14,26Zm0-2.4A9.6,9.6,0,1,0,4.4,14,9.6,9.6,0,0,0,14,23.6Zm-1.2-4.8L7.712,13.709l1.7-1.7L12.8,15.406l6.788-6.788,1.7,1.7Z"
        transform="translate(-2 -2)"
        fill="#bcbcbc"
      />
    </svg>
  );
}

export default TickIcon;
